module.exports = __webpack_public_path__ + "static/img/duofangguangbo2.52493df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/duofangguangbo2.png
// module id = ZT7/
// module chunks = 24